<template>
<div class="chapter">
<div class="inner_page">
<p class="cont">CONTENTS</p>
<p class="cont1"><a href="#/xhtml/chapter1">WELCOME TO SUCCESSFUL GARDENING IN UTAH!</a></p>
<p class="cont2"><a href="#/xhtml/chapter2">PROBLEMS AND SOLUTIONS</a></p>
<p class="cont2"><span href="#/xhtml/chapter3" title="Link target outside of Sample">SOLUTIONS FOR SUCCESSFUL GARDENING IN UTAH</span></p>
<p class="cont2"><span href="#/xhtml/chapter4" title="Link target outside of Sample">SEEDRENAISSANCE.COM GUIDE TO BASIC PLANTING IN THE ROCKY MOUNTAIN WEST</span></p>
<p class="cont2"><span href="#/xhtml/chapter5" title="Link target outside of Sample">OTHER INFORMATION</span></p>
<p class="cont2"><span href="#/xhtml/aboutauthor" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?61b02104